module.exports = __webpack_public_path__ + "img/user_activate.8ee0b5da.png";